import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import WaitingModal from '../../../containers/generics/WaitingModal';
import FlatButton from 'material-ui/FlatButton';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import Notifications from 'react-notify-toast';

var Config = require('../../../config');

class ModalLiberacion extends Component{
	constructor(props){
		super(props);
		
		this.handleClose = this.handleClose.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onLiberate = this.onLiberate.bind(this);

		this.state = {
			show: false, 
			reason_id:"",
			reasons:[],
			donation_id:0
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleClose(){
		this.setState({
			show: false
		});
	}

	handleShow(donation_id){
		this.setState({donation_id:donation_id});
		this.waiting_modal.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'lookups?type=RELEASE_REASONS&option=actives&order=true',{
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				console.log(res.text())
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					show:true, 
					reasons: response
				});

				this.waiting_modal.handleClose();
			}
		})

	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(e.target.value === ""){
			document.getElementById('reason_id').classList.add("error");
		}else{
			document.getElementById('reason_id').classList.remove("error");
		}
	}

	onLiberate(){
		if(this.state.reason_id === ""){
			document.getElementById('reason_id').classList.add("error");
			swal("Error", "Campos incompletos", 'error');
		}else{
			this.props.waiting.handleShow('Liberando...');
			fetch(Config.default.apiGateway.URL+'donations/'+this.state.donation_id+"?reason="+this.state.reason_id,{ 
	            method: 'delete',
	            headers: new Headers({
	               	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	               	'Accept': 'application/json',
	              	'Content-Type': 'application/json',
	            })
	      	}).then(res => {
	      		this.props.waiting.handleClose();
	            if(res.ok){
	              	return res.json();
	            }else{
	              	res.text().then(function(result) {
	                	swal('¡Error!', result, 'error');
	              	});
	            }
	        }).then(res => {
	          	if(res !== undefined){
	            	swal('¡Buen Trabajo!', 'Registro Eliminado','success');
	            	this.props.history.goBack();
	          	};
	      	});
		}
			
	}

	render(){
		const {t} = this.props;

		return (
			<div>
				<Modal show={this.state.show} onHide={this.handleClose}>
			       	<Modal.Header closeButton>
			        	<Modal.Title>Motivo de Liberación</Modal.Title>
			        </Modal.Header>
			        <Modal.Body >
			        	<div className="row">
			        		<div className="col-xs-12 form-group ">
			        			<div className="col-xs-12 col-sm-6">
				        			<label>Motivo de Liberación</label>
				        			<select className="form-control" id="reason_id" name="reason_id" value={this.state.reason_id || ""} 
				        				onChange={this.handleChange} required>
				        				<option value="">Seleccione...</option>
				        				{this.state.reasons.map((reason)=>{
				        					return <option key={reason.id} value={reason.name}>
				        						{reason.name}
				        					</option>
				        				})}
				        			</select>
			        			</div>
			        		</div>
			        	</div>
			        	
			        </Modal.Body>
			        <Modal.Footer>
			        	<FlatButton primary={true} label={t('content.generics.buttons.save')}  onClick={this.onLiberate}/>
			        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
			        </Modal.Footer>
		      	</Modal>
		      	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)} />
		      	<Notifications />
	      	</div>
		)
	}
}

export default translate('translations')(ModalLiberacion)